'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { PopupId, PopupPage } from '@flipster/apis/v1/popup/types';
import { useOverlay } from '@flipster/overlay';

import { EntryPageScope, PopupContext, entryPopupBunja } from './bunja';
import { AffiliateDashboardRenewalModal } from './modal/affiliate-dashboard-renewal-modal';
import { FollowOnboardingModal } from './modal/follow';
import { LeagueLeaderboardOnboardingModal } from './modal/league-leaderboard';
import { LeagueMainOnboardingModal } from './modal/league-main';
import { LeagueRecurringCompetitionModal } from './modal/league-recurring-tc';

const nodes: Record<PopupId, React.ReactNode> = {
  WELCOME_TO_TIERED_LEAGUE: <LeagueMainOnboardingModal />,
  TIERED_LEAGUE_DESCRIPTION: <LeagueLeaderboardOnboardingModal />,
  RECURRING_TC_OPEN: <LeagueRecurringCompetitionModal />,
  ADHOC_FOLLOW_ONBOARDING: <FollowOnboardingModal />,
  NEW_AFFILIATE_DASHBOARD: <AffiliateDashboardRenewalModal />,
};

interface EntryPopupProps {
  page: PopupPage;
}

export const EntryPopup = ({ page }: EntryPopupProps) => {
  const overlay = useOverlay();
  const { popupAtom } = useBunja(entryPopupBunja, [EntryPageScope.bind(page)]);
  const popup = useAtomValue(popupAtom);
  useEffect(() => {
    if (popup?.id) overlay.open(<PopupContext value={popup}>{nodes[popup.id]}</PopupContext>);
  }, [popup, overlay]);
  return null;
};
